import React, { useState } from 'react'
import { firestore } from '../../../firebase';

function AddIngredients({recipeId}) {

    const [ingredient, setIngredient] = useState("")
    const [unit, setUnit] = useState("")
    const [amount, setAmount] = useState(0)

    async function addIngredient(e) {
        e.preventDefault();

        try {
            const ingredientRef = firestore.collection("recipes").doc(recipeId).collection("ingredients");

            const data = {
                amount: +amount,
                amount_unit: unit,
                ingredient: ingredient
            }

            ingredientRef.add(data)
            setIngredient("")
            setAmount(0)
            setUnit("")
        } catch (error) {
            
        }

    }

    return (
        <form onSubmit={addIngredient}>
            <div className="row">
            
                <div className="col-lg-2">
                    <input value={amount} type="number" step="0.01" placeholder="Mengde" className="form-control mb-2" onChange={e => setAmount(e.target.value)} />
                </div>
                
                <div className="col-lg-4">
                    <input value={unit} className="form-control mb-2" placeholder="Enhet (e.g dl, tskj..)" onChange={e => setUnit(e.target.value)} />
                </div>

                <div className="col-lg-3">
                    <input value={ingredient} className="form-control mb-2" placeholder="Ingrediens" onChange={e => setIngredient(e.target.value)} />
                </div>

                <div className="col-lg-3">
                    <button className="btn btn-sm btn-block btn-danger">Legg til</button>
                </div>
            </div>
        </form>

    )
}
export default AddIngredients